/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable quotes */
import React from "react";
import "../styles/styles.scss";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';

const NotFoundPage = () => { const { t: tr } = useTranslation(); return (<div id="parent" className="blurred-background">
    <Helmet>
      <title>{tr("public:extraEnglish404Error_87")}</title>
    </Helmet>
    <h1>{tr("public:404ErrorPageNotFound_88")}</h1>
  </div>); };

export default NotFoundPage;
